import { Injectable } from '@angular/core';

/**
 * æ£æ¥è§å
 * @scope FormModule
 */
@Injectable()
class CheckService {

  constructor() {
  }

  /**
   * æ£æ¥æ¯å¦ä¸ºç©º
   */
  public checkEmpty(value: any) {
    return !!value;
  }
}

export { CheckService };
